import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom"; // Import useLocation
// Common
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

// Auth
import Login from "./components/auth/Login";
import Logout from "./components/auth/Logout";

// Public
import Home from "./components/public/Home"; // Import Home for visitors

// User Panel
import Sidebar from "./components/user/Sidebar";
import Dashboard from "./components/user/Dashboard";
import Users from "./components/user/Users";
import AccountSettings from "./components/user/AccountSettings";
import "./App.css";

import Properties from "./components/user/Properties";
import Enquiries from "./components/user/Enquiries";
import Attendance from "./components/user/Attendance ";
import Leads from "./components/user/Leads";
import Gallery from "./components/user/Gallery";
import Builder from "./components/user/Builder";
import Ammenities from "./components/user/Ammenities";
import Blog from "./components/user/Blog";
import PropertyTour from "./components/user/PropertyTour";
import TaskManagement from "./components/user/TaskManagement";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState(""); // State to store user role
  const location = useLocation(); // Now works correctly inside Router context

  useEffect(() => {
    const accessTokenCheck = localStorage.getItem("accessToken");
    if (accessTokenCheck) {
      setIsLoggedIn(true);
    }
  }, []);

  // Determine if the current route is "event/:eventUrlSlug"
  const isEventDetailPage = location.pathname.startsWith("/event/");
  const isEventFormPage = location.pathname.startsWith("/event-form/");

  // console.log({isEventDetailPage});

  return (
    <div className="App wrapper">
      {/* Conditionally render Sidebar based on login and role */}

      {isLoggedIn &&
        !isEventDetailPage && // Exclude Sidebar on EventDetail page
        !isEventFormPage && <Sidebar />}

      <div
        className={
          isLoggedIn && !isEventDetailPage && !isEventFormPage
            ? "main-panel"
            : ""
        }
      >
        {/* Conditionally render Header */}
        {isLoggedIn && !isEventDetailPage && !isEventFormPage && <Header />}

        {/* Routes */}
        <Routes>
          {/* Landing page for visitors */}
          <Route
            path="/"
            element={
              isLoggedIn ? <Navigate to={"/user/dashboard"} /> : <Home />
            }
          />

          <Route
            path="/login"
            element={<Login setIsLoggedIn={setIsLoggedIn} />}
          />
          <Route path="/logout" element={<Logout />} />

          {/* User routes */}
          <Route
            path="/user/dashboard"
            element={isLoggedIn ? <Dashboard /> : <Navigate to="/" />}
          />
          <Route
            path="/user/users"
            element={
              isLoggedIn ? (
                <Users />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Properties */}
          <Route
            path="/user/properties"
            element={
              isLoggedIn ? (
                <Properties />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          {/* Add a Ammenitties */}
          <Route
            path="/user/amenities"
            element={
              isLoggedIn ? (
                <Ammenities />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Enquiry*/}
          <Route
            path="/user/enquiry"
            element={
              isLoggedIn ? (
                <Enquiries />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          {/* Add a Attendance */}
          <Route
            path="/user/attendance"
            element={
              isLoggedIn ? (
                <Attendance />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          {/* Add a Lead Route */}
          <Route
            path="/user/leads"
            element={
              isLoggedIn ? (
                <Leads />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          {/* Add a Blog Route */}
          <Route
            path="/user/blogs"
            element={
              isLoggedIn ? (
                <Blog />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

        {/* Add a property tour Route */}
          <Route
            path="/user/property-tours"
            element={
              isLoggedIn ? (
                <PropertyTour />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Gallery Route */}
          <Route
            path="/user/gallery"
            element={
              isLoggedIn ? (
                <Gallery />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Builder Route */}
          <Route
            path="/user/builder"
            element={
              isLoggedIn ? (
                <Builder />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/task-management"
            element={
              isLoggedIn ? (
                <TaskManagement />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/account-settings"
            element={
              isLoggedIn ? (
                <AccountSettings />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Catch-all route to redirect to landing page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {/* Conditionally render Footer */}
        {isLoggedIn && !isEventDetailPage && !isEventFormPage && <Footer />}
      </div>
    </div>
  );
}

export default App;
